import React from 'react'
import aetnalogo from 'images/content/logo/aetna.jpeg'
import apexLogo from 'images/content/logo/apex.png'
import manhattanlifeLogo from 'images/content/logo/manhattanlife.png'
import cignaLogo from 'images/content/logo/cigna.jpeg'
import foresterLogo from 'images/content/logo/forester.jpeg'

import iaicLogo from 'images/content/logo/IAIC.png'
import kaiserLogo from 'images/content/logo/kaiser.jpeg'
import mutualOmahaLogo from 'images/content/logo/mutualOmaha.jpeg'
import palicLogo from 'images/content/logo/PALIC.jpeg'
import uhcLogo from 'images/content/logo/UHC.jpeg'

const Carriers = () => {

    const carriers = [
        {
            image: aetnalogo,
            name: 'Aetna'
        },
        {
            image: apexLogo,
            name: 'Apex'
        },
        {
            image: manhattanlifeLogo,
            name: 'ManhattanLife'
        },
        {
            image: cignaLogo,
            name: 'Cigna'
        },
        {
            image: foresterLogo,
            name: 'Forester'
        },

        {
            image: iaicLogo,
            name: 'IAIC'
        },
        {
            image: kaiserLogo,
            name: 'Kaiser'
        },
        {
            image: palicLogo,
            name: 'PALIC'
        },
        {
            image: uhcLogo,
            name: 'UHC'
        },
    ]

    return (
        <>
            <div className='text-2xl sm:text-4xl font-bold text-center'>We Work with Top Group Health Insurance Providers</div>

            <div className='flex flex-col items-center'>
                <ul className='flex flex-wrap justify-center gap-4 w-full'>
                    {
                        carriers.map(carrier => (
                            <li className='flex items-center justify-center py-2 px-2 max-w-48' key={carrier.name}>
                                <img className='w-full h-auto' src={carrier.image} alt='carrier logo' />
                            </li>
                        ))
                    }
                </ul>
            </div>
        </>
    )
}

export default Carriers